export default __webpack_public_path__ + "static/media/txt_logo_fr.fbf63477.svg";